import React from "react";
import { Upload } from "antd";
import StorageUtils from "../../../utils/storage-session-utils";
import notifyUtitls from "../../../utils/notify-utils";
import useUploadStatus from "../use-upload-status";

/** NMU-524: "5 MB", not "5242880 bytes" — the message is for an editor. */
const formatSize = (bytes) => {
  const mb = bytes / (1024 * 1024);
  return `${Number.isInteger(mb) ? mb : mb.toFixed(1)} MB`;
};

const UploadFile = ({ children, limitSize, onChange, ...props }) => {
  const { fileList = [] } = props;
  const uploadTempEndpoint =
    process.env.REACT_APP_API_ENDPOINT + "/upload/temp";
  const headers = {
    Authorization: "Bearer " + StorageUtils.getToken(),
  };
  /*
    NMU-524: the same progress / success / failure reporting the image uploader
    uses. This one said nothing at all — not even when the upload failed.
  */
  const withStatus = useUploadStatus(limitSize ? formatSize(limitSize) : undefined);

  const beforeUpload = (file) => {
    const duplicate = fileList.find(({ name }) => name === file.name);
    if (duplicate) {
      notifyUtitls.warning("แจ้งเตือน", "ไฟล์อัพโหลดมีชื่อซ้ำ!");
      return Upload.LIST_IGNORE;
    }

    const filename = file.name.length > 75;
    if (filename) {
      notifyUtitls.warning("แจ้งเตือน", "ชื่อไฟล์ต้องไม่เกิน 75 ตัวอักษร");
      return Upload.LIST_IGNORE;
    }

    //TODO: validate ext.
    // if (!file.type.includes("image/")) {
    //   notifyUtitls.error({
    //     title: "แจ้งเตือน",
    //     message: "ประเภทไฟล์รูปภาพไม่ถูกต้อง",
    //   });
    //   return Upload.LIST_IGNORE;
    // }

    if (file.size === 0) {
      // NMU-524: an empty file used to be reported as too *large*, quoting a
      // limit it was nowhere near — a reason that sends an editor looking in
      // exactly the wrong direction.
      notifyUtitls.error({
        title: "แจ้งเตือน",
        message: "ไม่สามารถอัปโหลดไฟล์ได้ ไฟล์นี้ไม่มีข้อมูล (0 ไบต์)",
      });
      return Upload.LIST_IGNORE;
    }

    if (limitSize && file.size > limitSize) {
      notifyUtitls.error({
        title: "แจ้งเตือน",
        message: `ไม่สามารถอัปโหลดไฟล์ได้ กรุณาเลือกไฟล์ที่มีขนาดไม่เกิน ${formatSize(limitSize)}`,
      });
      return Upload.LIST_IGNORE;
    }
  };

  return (
    <Upload
      {...props}
      action={uploadTempEndpoint}
      method="POST"
      headers={headers}
      beforeUpload={beforeUpload}
      onChange={withStatus(onChange)}
    >
      {children}
    </Upload>
  );
};

export default UploadFile;
